import styled from 'styled-components';
import { Radio } from 'components/Base/Radio';
import { isDisabilityObservableOptions } from 'data/datas/genericData';
import { SecondaryText, Text } from 'components/Base/Typography';
import { Colors } from 'core/CssVariables';
import { FC } from 'react';

type Props = {
  isYesNoOptionValues?: boolean; // string values 'Yes' | 'No'
};

const DisabilityOptions: FC<Props> = ({ isYesNoOptionValues }) => {
  return (
    <>
      {isDisabilityObservableOptions.map(({ value, label, description }) => (
        <SRadio
          value={
            isYesNoOptionValues && value
              ? 'Yes'
              : isYesNoOptionValues && !value
              ? 'No'
              : value
          }
          label={
            <SecondaryText
              style={{
                color: Colors.Dark,
              }}
              fontWeight={400}
              fontLevel={5}
            >
              <Text fontLevel={5} className="mr-1">
                {label}:
              </Text>
              {description}
            </SecondaryText>
          }
          key={label}
        />
      ))}
    </>
  );
};

export default DisabilityOptions;

const SRadio = styled(Radio)`
  &&.ant-radio-wrapper {
    :not(:first-child) {
      margin-top: 8px;
    }
    .ant-radio {
      margin: 0 0px 0px 0;
    }
  }
`;
